'use strict';

goog.provide("Ntry.MazeIntro");

Ntry.MazeIntro = function() {
    this._view = Ntry.interfaceManager.getDom('ntryIntroArea');
    this.createDom();
    Ntry.addEventListener('changeMode', this, this.setMode);
    this.textModeShown = false;
    this.blockModeShown = false;
};

(function(p){

    p.createDom = function () {
        var parent = this._view;
        var container = Ntry.createElement('div', parent, null, 'ntryIntroContainer');
        var title = Ntry.createElement('div', container, null, 'ntryIntroTitle')
        this._closeButton = Ntry.createElement('span', title, null, 'ntryIntroCloseButton');
        this._closeButton.innerHTML = Lang.Menus.close;

        var content = Ntry.createElement('div', container, null, 'ntryIntroContent');
        this._leftImg = Ntry.createElement('div', content, null, 'ntryIntroLeftImg');

        var rightDiv = Ntry.createElement('div', content, null, 'ntryIntroRightDiv');
        this._rightTop = Ntry.createElement('div', rightDiv, null, 'ntryIntroRightTop');
        this._rightCenter = Ntry.createElement('div', rightDiv, null, 'ntryIntroRightCenter');

        this._startButton = Ntry.createElement('span', content, null, 'ntryIntroStartButton');
        this._startButton.innerHTML = Lang.Workspace.run;

        var self = this;
        this._view.bindOnClick(function(e) {
            if (e.target == this) {
                self.hide();
            }
        });
    };

    p.hide = function () {
        Ntry.dispatchEvent('hideIntro', this.mode);
        $(this._view).css('display', 'none');
    }

    p.update = function() {
    };

    p.loadConfig = function () {
        this._intro = Ntry.configManager.getConfig('intro');
        if (this._intro)
            this.fillContent();
    };

    p.fillContent = function() {
        var intro = this._intro;
        var stageId = Ntry.configManager.getConfig("stageId");

        this._leftImg.removeClasses();
        this._leftImg.addClass('ntryIntroLeftImg');
        if (stageId <= 6)
            this._leftImg.addClass('ntryIntroLeft1Img');
        else if (stageId <= 14)
            this._leftImg.addClass('ntryIntroLeft2Img');
        else
            this._leftImg.addClass('ntryIntroLeft3Img');

        this._rightTop.innerHTML = stageId + '/20';
        this._rightCenter.innerHTML = intro.content;

        var self = this;
        this._closeButton.bindOnClick(function() {
            self.hide();
        });

        this._startButton.bindOnClick(function() {
            self.hide();
        });

        $(this._view).css('display', 'block');
    };

    p.setMode = function(mode) {
        mode = mode === undefined ? 0 : mode;
        mode = isNaN(mode) ? mode.boardType : mode;
        this.mode = Number(mode);
        if(Entry.Workspace.MODE_BOARD === this.mode && !this.blockModeShown) {
            this._rightCenter.innerHTML = this._intro.content;
            $(this._view).css('display', 'block');
            this.blockModeShown = true;
        } else if(Entry.Workspace.MODE_VIMBOARD === this.mode && !this.textModeShown){
            this._rightCenter.innerHTML = this._intro.textContent || '';
            $(this._view).css('display', 'block');
            this.textModeShown = true;
        }
    }


})(Ntry.MazeIntro.prototype);
